import { observer } from "mobx-react-lite";
import { ReactComponent as EditIcon } from "images/editIcon.svg";
import { Tooltip } from "antd";
import { useStores } from "stores";

import { CurrencyCodeEditModal } from "./CurrencyCodeEditModal";

export const CurrencyCodeEditBtn = observer(() => {
  const { actionModals, bidCard } = useStores();

  const openModalHandler = () => {
    actionModals.open(() => <CurrencyCodeEditModal />, {
      title: "Изменить код вида операции",
      width: "600px",
      onApply: () => {
        return Promise.resolve();
      },
    });
  };
  return (
    <Tooltip title="Изменить код вида операции">
      <EditIcon className="cursor-pointer" onClick={openModalHandler} />
    </Tooltip>
  );
});
